(function () {
  function setup(root) {
    if (root.dataset.gwReady) return;
    root.dataset.gwReady = '1';
    var track = root.querySelector('[data-gw-track]');
    var dots = root.querySelector('[data-gw-dots]');
    var prev = root.querySelector('[data-gw-prev]');
    var next = root.querySelector('[data-gw-next]');
    if (!track) return;
    var items = Array.prototype.slice.call(track.children);

    function step() {
      return items.length > 1 ? items[1].offsetLeft - items[0].offsetLeft : track.clientWidth;
    }
    function pages() {
      var perView = Math.max(1, Math.round(track.clientWidth / step()));
      return Math.max(1, items.length - perView + 1);
    }
    function current() {
      return Math.round(track.scrollLeft / step());
    }
    function arrows() {
      var max = track.scrollWidth - track.clientWidth;
      if (prev) prev.style.display = track.scrollLeft > 4 ? '' : 'none';
      if (next) next.style.display = max > 4 && track.scrollLeft < max - 4 ? '' : 'none';
    }
    function render() {
      arrows();
      if (!dots) return;
      var n = track.scrollWidth > track.clientWidth + 2 ? pages() : 0;
      if (dots.childElementCount !== n) {
        dots.innerHTML = '';
        for (var i = 0; i < n; i++) {
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', 'Slide ' + (i + 1));
          (function (idx) {
            b.addEventListener('click', function () {
              track.scrollTo({ left: idx * step(), behavior: 'smooth' });
            });
          })(i);
          dots.appendChild(b);
        }
      }
      var c = current();
      Array.prototype.forEach.call(dots.children, function (b, i) {
        b.setAttribute('aria-current', i === c ? 'true' : 'false');
      });
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(render); }, { passive: true });
    window.addEventListener('resize', render);
    render();
  }

  function setupCompare(root) {
    if (root.dataset.gwReady) return;
    root.dataset.gwReady = '1';
    var input = root.querySelector('input[type=range]');
    function sync() { root.style.setProperty('--pos', input.value + '%'); }
    input.addEventListener('input', sync);
    sync();
  }

  function setupRings(root) {
    if (root.dataset.gwReady) return;
    root.dataset.gwReady = '1';
    function go() { root.classList.add('is-in'); }
    if (!('IntersectionObserver' in window)) return go();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { go(); io.disconnect(); } });
    }, { threshold: 0.3 });
    io.observe(root);
  }

  function init() {
    document.querySelectorAll('[data-gw-slider]').forEach(setup);
    document.querySelectorAll('[data-gw-compare]').forEach(setupCompare);
    document.querySelectorAll('[data-gw-rings]').forEach(setupRings);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
